import React, { useState } from 'react';
import "../css/style.css";
import "../css/intro.css";
import TextType from "./textType";
import MagneticButton from "./MagneticButton";
import useParallax from '../hooks/useParallax';
import { motion } from 'framer-motion';

export default function Intro() {
  const [isHovered, setIsHovered] = useState(false);
  const parallaxOffset = useParallax(0.3);

  return (
    <div className="introArea" id="main">
      <motion.div
        className="hover-box textArea"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="testAbove">Hi, I'm</div>

        <TextType
          text={["Ghyas Ali Naqvi", "Expert in BootStrap", "Frontend Developer"]}
          typingSpeed={100}
          deletingSpeed={50}
          pauseDuration={1500}
          textColors={["#00FFAA", "#FFAD00", "#00BFFF"]}
          showCursor={true}
        />

        <div className="Magic">
          <MagneticButton active={isHovered}>
            <a href="#contact" className="custom-button">
              Get in touch!
            </a>
          </MagneticButton>
        </div>
      </motion.div>

      <motion.div
        className="imageArea"
        style={{ transform: `translateY(${parallaxOffset}px)` }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
      >
        <img className="image" src="/images/work.png" alt="Ghyas Ali" loading="eager" />
      </motion.div>
    </div>
  );
}
